<template>
  <div>
    <div class="intro-y flex gap-6 mb-4">
      <div class="box p-4 py-3">
        <div class="text-gray-500 text-xs">Сүүлийн 6 сарын цалингийн дундаж</div>
        <div class="text-lg font-semibold mt-1">{{ last6MonthsAvgSalary.toLocaleString() }}₮</div>
      </div>
      <div class="box p-4 py-3">
        <div class="text-gray-500 text-xs">Сүүлийн 12 сарын цалингийн дундаж</div>
        <div class="text-lg font-semibold mt-1">{{ last12MonthsAvgSalary.toLocaleString() }}₮</div>
      </div>
    </div>
    <CustomerSocialInsurance
      :loading="false"
      :rows="customer.socialInsurances || []"
      :columns="columns"
      :line-numbers="true"
    />
  </div>
</template>

<script>
import CustomerSocialInsurance from '@/components/customer/CustomerSocialInsurance';

export default {
  props: {
    customer: Object,
  },

  data() {
    return {
      columns: [
        {
          label: this.$t('socialInsurance.domName'),
          field: 'domName',
          filterable: true,
        },
        {
          label: this.$t('socialInsurance.orgSiId'),
          field: 'orgSiId',
          filterable: true,
        },
        {
          label: this.$t('socialInsurance.orgName'),
          field: 'orgName',
        },
        {
          label: this.$t('socialInsurance.year'),
          field: 'year',
        },
        {
          label: this.$t('socialInsurance.month'),
          field: 'month',
        },
        {
          label: this.$t('socialInsurance.salaryAmount'),
          field: 'salaryAmount',
        },
        {
          label: this.$t('socialInsurance.salaryFee'),
          field: 'salaryFee',
        },
        {
          label: this.$t('socialInsurance.paid'),
          field: 'paid',
        },
      ],
    };
  },

  computed: {
    sortedInsurances() {
      return [...(this.customer.socialInsurances || [])].sort(
        (a, b) => b.year - a.year || b.month - a.month
      );
    },
    last6MonthsAvgSalary() {
      const rows = this.sortedInsurances.slice(0, 6);
      if (!rows.length) return 0;
      return Math.round(
        rows.reduce((sum, r) => sum + Number(r.salaryAmount || 0), 0) / rows.length
      );
    },
    last12MonthsAvgSalary() {
      const rows = this.sortedInsurances.slice(0, 12);
      if (!rows.length) return 0;
      return Math.round(
        rows.reduce((sum, r) => sum + Number(r.salaryAmount || 0), 0) / rows.length
      );
    },
  },

  components: {
    CustomerSocialInsurance,
  },
};
</script>
